
    import has from 'lodash/has';
    import { mapState, mapGetters } from 'vuex';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import {
        faCaretLeft as fasCaretLeft,
    } from '@fortawesome/pro-solid-svg-icons/faCaretLeft';

    import SeekerAvatar from '@/components/Seeker/SeekerAvatar';

    export default {
        name: 'HistogramSeekerPointer',

        components: {
            SeekerAvatar,
            FontAwesomeIcon,
        },

        data() {
            return {
                icons: {
                    fasCaretLeft,
                },
            };
        },

        computed: {
            ...mapState({
                $_me: state => state.me.user,
            }),

            ...mapGetters('job', {
                $_isChartTypeRange: 'isChartTypeRange',
                $_isPayTypeAnnual: 'isPayTypeAnnual',
                $_marketPay: 'marketPay',
                $_chartData: 'chartData',
                $_isChartTypeHistogram: 'isChartTypeHistogram',
            }),

            pointerLength() {
                return this.$_isChartTypeHistogram ? 10 : 1;
            },

            hasSeekerDesiredPay() {
                return has(this.$_me, 'minPayBand.value') && this.$_me.minPayBand.value !== '-1.00';
            },

            seekerDesirePayPosition() {
                if (!this.hasSeekerDesiredPay) {
                    return '';
                }

                const desiredPay = this.$_me.minPayBand;
                let desiredPayValue = desiredPay.value;
                const maxDesiredAnnualValue = 350000;
                const maxDesiredHourlyValue = 150;

                if (desiredPay.pay_type_id === 1 && desiredPayValue >= maxDesiredAnnualValue) {
                    desiredPayValue = maxDesiredAnnualValue;
                } else if (desiredPay.pay_type_id === 2 && desiredPayValue >= maxDesiredHourlyValue) {
                    desiredPayValue = maxDesiredHourlyValue;
                }

                if ((this.$_isPayTypeAnnual && desiredPay.pay_type_id !== 1)) {
                    desiredPayValue = Math.round(desiredPayValue * 1976);
                }

                let maxPay = this.$_marketPay.payMax;
                let percent = 0;

                if (this.$_isChartTypeHistogram) {
                    maxPay = this.$_chartData[this.$_chartData.length - 1].min_pay;
                    if (maxPay > desiredPayValue) {
                        percent = Math.round(((desiredPayValue - this.$_chartData[0].min_pay) * (100 * (this.$_chartData.length - 1) / this.$_chartData.length)) / (maxPay - this.$_chartData[0].min_pay));
                    } else if (desiredPayValue >= maxDesiredAnnualValue) {
                        percent = 100;
                    } else {
                        percent = Math.round((100 * ((this.$_chartData.length - 1) / this.$_chartData.length)) + ((desiredPayValue - maxPay) / (this.$_marketPay.payMax - maxPay) * (100 * (1 / this.$_chartData.length))));
                    }
                } else {
                    percent = Math.round(((desiredPayValue - this.$_marketPay.payMin) * 100 / (this.$_marketPay.payMax - this.$_marketPay.payMin)));
                }

                // Make sure the desire salary pointer never gets out of the chart
                // The percent number should never be 0 or 100 because we want to cover
                // the stripe line by the vertical bar
                if (percent >= 100) {
                    percent = 99.2;
                } else if (percent <= 0) {
                    percent = 0.2;
                }

                return `${percent}%`;
            },

            avatarArrowClass() {
                if (!this.hasSeekerDesiredPay) {
                    return '';
                }

                const desiredPayValue = this.$_me.minPayBand.value;

                const maxPay = this.$_marketPay.payMax;
                const minPay = this.$_marketPay.payMin;

                let output = '';
                if (desiredPayValue < minPay) {
                    output = 'is-left';
                } else if (desiredPayValue > maxPay) {
                    output = 'is-right';
                }

                return [
                    'seeker-pointer__arrow',
                    output,
                ];
            },
        },

        methods: {},
    };
